
<template>
  <div>
    <label
      v-if="label"
      class="mb-7 text-gray-primary">{{ label }}</label>
    <input
      v-if="number"
      v-model="value"
      type="number"
      name="text"
      class="fs-14 py-6 px-16 rounded-4 d-flex w-100 text-field bm-input number-field"
      @keypress.enter="onEnterPress"
      @blur="onEnterPress"
      @keyup="checkSizeLimit" >
    <input
      v-else
      v-model="value"
      type="text"
      name="text"
      class="fs-14 py-6 px-16  d-flex w-100 text-field bm-input number-field border-1 border border-light-gray rounded-4"
      @keypress.enter="onEnterPress"
      @blur="onEnterPress"
    >
  </div>
</template>
<script>
import EventBus from '../../EventBus';

export default {
  name: 'TextField',

  props: {
    label:              String,
    number:             Boolean,
    dropoption:         Boolean,
    value:              { Boolean, Number, String },
    secondValue:        { Number, String },
    inchesValue:        Number,
    isInch:             Boolean,
    isProductSizeRatio: Boolean,
  },
  data() {
    return {
      isDropdownShown:        false,
      invalidKeyInput:        '',
      selectedOption:         'Pixels',
      valuechange:            'Inches',
      validSize:              this.isInch ? 100 : 7200,
      validSizeLimitInInches: 100,
      validSizeLimitInPixels: 7200,
    };
  },
  mounted() {
    EventBus.$on('resetToPixels', this.resetInchesToPixels);
  },
  methods: {
    checkSizeLimit() {
      const compareValue = this.value !== '' ? this.value : 0;
      if (this.isInch && parseFloat(compareValue) <= this.validSizeLimitInInches) {
        this.validSize = _.cloneDeep(parseFloat(compareValue));
      } else if (!this.isInch && parseInt(compareValue, 10) <= this.validSizeLimitInPixels) {
        this.validSize = _.cloneDeep(parseInt(compareValue, 10));
      } else {
        this.value = this.isInch ? _.cloneDeep(parseFloat(this.validSize)) : _.cloneDeep(parseInt(this.validSize));
      }
    },
    onEnterPress(e) {
      if (this.label === 'Width' || this.label === 'Height') {
        let newWidth  = 0;
        let newHeight = 0;
        if (this.label === 'Width') {
          newWidth  = this.value === '' ? 0 : this.isInch ? parseFloat(this.value) / 0.013888888888888888 : parseInt(this.value, 10);
          newHeight = null;
        }
        if (this.label === 'Height') {
          newWidth  = null;
          newHeight = this.value === '' ? 0 : this.isInch ? parseFloat(this.value) / 0.013888888888888888 : parseInt(this.value, 10);
        }
        const data = {
          label: this.label,
          newWidth,
          newHeight,
        };
        EventBus.$emit('changeProductSizeAfterResize', data);
      } else if (this.label === 'Product title') {
        EventBus.$emit('changeProductName', this.value);
      }
      if (e.key === 'e') {
        e.preventDefault();
      }
    },
    selected(e) {
      const temp          = this.selectedOption;
      this.selectedOption = e.target.innerText;
      this.valuechange    = temp;
      if (e.target.innerText === 'Inches') {
        EventBus.$emit('updateInchesValue');
      } else { EventBus.$emit('resetValue'); }
    },
    resetInchesToPixels() {
      this.selectedOption = 'Pixels';
      this.valuechange    = 'Inches';
    },
  },

};

</script>
<style lang="scss">
  .show-content {
    &.dropdown-panel {
    border-color: $blue50 !important;
    &:hover {
        border-color: $blue50 !important;
    }

    .dropdown-selection {
      display: block !important;
    }

    .custom-icon{
      transform: rotate(-180deg) !important;
    }
  }
  }

  .text-field{
    width: 84px !important;
  }

  .dropdown-panel{
    width: 96px !important;
    height: 36px;
    &:hover{
      border-color: $grey40 !important;
    }
  }

</style>
